export const setRoleFeatures = (features) => {
    console.log('Dispatching role features:', features);
  
    return {
      type: "ROLE_FEATURES",
      payload: features
    };
  };
  